import { getTimezoneShortLabel, toValidDate } from "../utils/date";
import { formatScheduleDateTimeLabel } from "./ScheduleDateLabel";
import { POST_NOW_FIRING_HINT } from "./publicationFlow/postNow";
import type { PublicationStatusBadgeKind } from "./publicationFlow/publicationStatusBadge";
import { getPublicationStatusPresentation } from "./publicationFlow/publicationStatusPresentation";

export default function PublicationStatusTooltipContent({
  kind,
  scheduledAt,
  errorMessage,
  showLabel = true,
}: {
  kind: PublicationStatusBadgeKind;
  scheduledAt?: Date | null;
  errorMessage?: string | null;
  /** Omit the heading when the anchor already displays the status label. */
  showLabel?: boolean;
}) {
  const label = kind === "scheduled"
    ? "Already scheduled"
    : getPublicationStatusPresentation(kind).label;
  const date = toValidDate(scheduledAt);
  const hints: Partial<Record<PublicationStatusBadgeKind, string>> = {
    scheduled: date
      ? `${formatScheduleDateTimeLabel(date)}, ${getTimezoneShortLabel(date)}`
      : "Saved to your schedule.",
    queued: POST_NOW_FIRING_HINT,
    publishing: "Will be live soon.",
    failed: errorMessage || "Your post couldn’t be published.",
  };
  return (
    <span className="flex flex-col gap-0.5">
      {showLabel ? <span className="font-medium text-tooltip-foreground">{label}</span> : null}
      {hints[kind] ? (
        <span className={showLabel ? "text-slate-400" : "text-tooltip-foreground"}>{hints[kind]}</span>
      ) : null}
    </span>
  );
}
